/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const RelayClassic16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M2.8 2a.8.8 0 01.8.8H10v1.6h4l-.001.001.001.001L12.404 7.6 14 10.79h-.009l.009.01h-.812l-.08.002-.001-.002H8.479L9.2 9.2H3.6v4a.8.8 0 11-1.6 0V2.8a.8.8 0 01.8-.8zm9.908 8h-3.06l-.001.002 3.068.013-.007-.015z"
        />
    </AccessibleSVG>
);

export default RelayClassic16;
